var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpathLogoColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.4 148.3",
    style: {
      enableBackground: "new 0 0 508.4 148.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFCF4D;}\r\n\t.st2{fill:#1073BA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000135666998207954038020000007143009800775450005_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 508.4,
    height: 148.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,80.5c-11.7,41.5,11.6,62.6,11.6,62.6l19.6-20.4C88.6,101.3,78.8,80.5,78.8,80.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.9,23.3c-38.4,39.8-46.4,94.3-20.1,121.6l-1.3,1.5C49.1,106.6,50.1,41.5,88.6,1.7L108.9,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143.3,80.6h-4.2v30.6h4.2V80.6z M178,111.2V80.6h-3.8v20.1c0,1.4,0,2.9,0.2,4.3h-0.1 c-0.2-0.4-1.4-2.4-2.9-4.6l-13.8-19.8h-4.1v30.6h3.8V89.7c0-1.2,0-2.3-0.2-3.5h0.1c0.8,1.4,1.6,2.8,2.5,4.1l14.5,20.9H178z  M203.6,103.4c0-5.9-4.5-7.9-8.5-9.9c-3.1-1.4-5.6-2.7-5.6-5.7c0-2.7,2.2-4.3,5.1-4.3c2.3-0.1,4.5,0.7,6.2,2.1l1.9-3 c-2.4-1.7-5.3-2.6-8.2-2.5c-4.8,0-9.1,2.9-9.1,7.9s3.3,6.9,7,8.8c3.5,1.7,7,3.2,7,6.7c0,2.6-2.3,4.9-6,4.9c-2.5,0-5-0.9-6.9-2.6 l-2,2.9c2.5,2.1,5.7,3.2,8.9,3.1C199.5,111.8,203.6,108.3,203.6,103.4 M230.4,84.1v-3.5h-21.5v3.5h8.6v27.1h4.2V84.1L230.4,84.1z  M242.3,80.6h-4.2v30.6h4.2V80.6z M271.5,84.1v-3.5H250v3.5h8.6v27.1h4.2V84.1L271.5,84.1z M302.5,99.4V80.6h-3.9v19.2 c0,5-2.5,8.4-7.8,8.4c-5.6,0-8-2.9-8-9V80.6h-4.1v19.1c0,7.4,3.6,12.1,12.1,12.1C298.8,111.8,302.5,107.1,302.5,99.4 M331.4,84.1 v-3.5h-21.5v3.5h8.6v27.1h4.2V84.1L331.4,84.1z M355.3,111.2v-3.5H343V96.8h10.5v-3.4H343v-9.2h12v-3.5h-16.1v30.6L355.3,111.2 L355.3,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.3,64.3l-1.8-2.9c-2.1,1.8-4.7,2.7-7.4,2.6c-7.3,0-10.8-6-10.8-12.5s3.6-12.2,10.7-12.2 c2.4-0.1,4.8,0.6,6.8,2l2-3.1c-2.6-1.7-5.6-2.5-8.7-2.3c-9.6,0-15.2,7.5-15.2,15.8s5.4,15.9,15.1,15.9 C156.3,67.4,159.7,65.8,161.3,64.3 M188.9,66.9l-7.3-10.3c-0.9-1.5-2-2.8-3.3-3.9v-0.1c4.6-0.4,8.3-2.9,8.3-8 c0-5.3-3.8-8.3-10.4-8.3h-8.7v30.6h4.2V53.1h0.5c2,0,2.5,0.4,5.8,5.1l6.1,8.7H188.9z M182.5,44.7c0,3.3-2,5.1-6.3,5.1h-4.4V39.7 h4.1C180.4,39.7,182.5,41.4,182.5,44.7 M200.9,36.3h-4.2v30.6h4.2V36.3z M230.1,39.8v-3.5h-21.5v3.5h8.6v27.1h4.2V39.8L230.1,39.8 z M242,36.3h-4.2v30.6h4.2V36.3z M275.6,64.3l-1.8-2.9c-2.1,1.8-4.7,2.7-7.4,2.6c-7.3,0-10.8-6-10.8-12.5s3.6-12.2,10.7-12.2 c2.4-0.1,4.8,0.6,6.8,2l2-3.1c-2.2-1.5-4.8-2.3-8.7-2.3c-9.6,0-15.2,7.5-15.2,15.8s5.4,15.9,15.1,15.9 C270.6,67.4,274,65.8,275.6,64.3 M287.2,59.6h13.6l2.7,7.2h4.5l-11.8-30.6h-4l-11.7,30.6h4.1L287.2,59.6z M299.5,56.2h-11l3.6-9.9 c0.9-2.5,1.8-5.2,1.8-5.3h0.1c0,0,0.9,2.7,1.8,5.3L299.5,56.2z M331.5,66.9v-3.4h-11.9V36.3h-4.1v30.6L331.5,66.9z M371.1,45.3 c0-6-4.7-9-10.9-9H352v30.6h4.2V54.8h3.4C366.8,54.8,371.1,51.4,371.1,45.3 M366.9,45.4c0,4-2.1,6-7.2,6h-3.4V39.7h3.6 C364.9,39.7,366.9,42,366.9,45.4 M379.9,59.6h13.6l2.7,7.2h4.5l-11.8-30.6h-4l-11.7,30.6h4.1L379.9,59.6z M392.2,56.2h-11l3.6-9.9 c0.9-2.5,1.8-5.2,1.8-5.3h0.1c0,0,0.9,2.7,1.8,5.3L392.2,56.2z M422.4,39.8v-3.5h-21.5v3.5h8.6v27.1h4.2V39.8L422.4,39.8z  M454.8,66.9V36.3h-4.2v12.8H434V36.3h-4.2v30.6h4.2V52.6h16.6v14.3H454.8z"
  })))), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1154,
    height: 974,
    xlinkHref: "../../../Portal-CPATH/src/images/CPath_RDCA_logo_vertical.png",
    transform: "matrix(0.24 0 0 0.24 -424.48 188.12)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpathLogoColour);
export default __webpack_public_path__ + "static/media/cpath_logo_colour.f1b7332e3bb0bf96a43db799298cc140.svg";
export { ForwardRef as ReactComponent };